module.exports = __webpack_public_path__ + "img/staffrequest.d2067415.svg";